<template>
  <div class="about">
    <img src="../assets/image/title.png"/>
    <div class="center">
      <!--      {{num}}-->
      <!--      必须使用@submit 提交表单 否则不能监听必填验证-->
      <van-form @submit="submit">
        <van-field
            :rules="[{ required: true,  }]"
            label="姓名"
            name="name"
            placeholder="请填入姓名"
            v-model="form.nickName"
        />
        <van-field
            :rules="[{ required: true,  }]"
            :value="value"
            @click="showSex = true"
            clickable
            is-link
            label="性别"
            name="picker"
            placeholder="请选择性别"
            readonly
        />
        <van-popup position="bottom" v-model="showSex">
          <van-picker
              :columns="columns"
              @cancel="showSex = false"
              @confirm="onConfirm"
              class="my"
              show-toolbar
              style="font-size:50px;"
          />
        </van-popup>

        <van-field
            :rules="[{ required: true,}]"
            label="年龄"
            name="age"
            placeholder="请输入您的年龄"
            type="digit"
            v-model="form.age"
        />

        <van-field
            :rules="[{ required: true,  }]"
            label="手机号码"
            name="phone"
            placeholder="请输入手机号码"
            type="tel"
            v-model="form.phone"
        />
        <van-field
            :rules="[{ required: true, },{validator, message: '身份证号码格式错误！'}]"
            label="身份证号"
            name="phone"
            placeholder="请输入身份证号/护照号"
            v-model="form.idCard"
        />

        <van-field
            :rules="[{ required: true,  }]"
            :value="currentDate"
            @click="showPicker = true"
            clickable
            is-link
            label="时间选择"
            name="datetimePicker"
            placeholder="点击选择时间"
            readonly
        />
        <van-popup position="bottom" v-model="showPicker">
          <van-datetime-picker
              :max-date="maxDate"
              :min-date="minDate"
              @cancel="showPicker = false"
              @confirm="selectTime"
              class="my-picker"
              title="选择年月日"
              type="date"
              v-model="form.appointmentTime"/>
          <van-picker
              :columns="column"
              @change="onChange"
              class="my-picker" v-model="form.timeRange"/>
        </van-popup>

        <div style="margin: 16px;">
          <van-button block native-type="submit" round type="info">预约</van-button>

          <van-button @click.native="myBook" block class="secondButton" round type="info">我的预约
          </van-button>
        </div>
      </van-form>
    </div>
    <div class="end">
      <h4>温馨提示:</h4>
      <p>新冠核酸筛查自报告时间起7天内有效</p>
      <p>采样后24小时出报告，请准确预估时间</p>
      <p>出国人员请填护照上的英文名和护照号码</p>
    </div>

  </div>
</template>
<script>
import {SubmitOrder, getDetail} from '@/api/order/index.js';
import {Toast} from 'vant';

export default {
  name: 'login',
  data() {
    return {
      num: '获取验证码',
      form: {
        nickName: '',
        openId: this.$route.query.openId,
        phone: '',
        idCard: '',
        appointmentTime: '',
        projectId: this.$route.query.id,
        timeRange: '上午9:00-12:00'
      },
      value: '',
      showPicker: false,
      showSex: false,
      columns: ['男', '女'],
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      currentDate: '',
      column: ['上午9:00-12:00', '下午12:30-5:30'],
      columnsValue: '上午9：00-12：00'
    };
  },
  created() {
    let dateLimit = new Date();
    //今天时间  只能选择今天之后的日期
    this.minDate = new Date(this.$moment(dateLimit).format('YYYY/MM/DD'));
    // this.form.openid=
    // this.getOpenid()
    sessionStorage.setItem('openId', this.$route.query.openId);
  },
  methods: {
    //身份证正则验证
    validator(val) {
      const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
      const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      const PassportNumberReg = /^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/;
      const cartTw = /^[a-zA-Z][0-9]{9}$/;
      return card15.test(val) || card18.test(val) || cartTw.test(val) || PassportNumberReg.test(val);
    },
    //提交预约
    submit() {//发起请求
      this.form.appointmentTime = sessionStorage.getItem('appointmentTime');
      console.log(this.form.appointmentTime);
      SubmitOrder(this.form).then(res => {
        //判断后端返回的 res.data.code是否为200
        if (res.data.code === 200) {
          //如果是200 代表请求成功 提示客户已经预约成功
          this.$dialog.alert({
            title: "预约成功",
            message: "1.请携带身份证或护照或户口本，带好口罩于预约的采样日期前去采样。" +
                "<br>2.采样前2小时内请勿进食，采样前30分钟内请勿喝水。"
          }).then(() => {
            this.form = {};
            this.value = '';
            this.currentDate = '';
          });
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    onConfirm(value) {
      this.value = value;
      value === '男' ? this.form.sex = 1 : this.form.sex = 2;
      console.log(this.form.sex);
      this.showSex = false;
    },
    // 选择到的时间
    selectTime(val) {

      this.currentDate = this.timeFormat(val) + this.columnsValue;
      console.log(this.timeFormat(val));
      // if(this.timeFormat(val) === '2021-02-10' &&this.form.timeRange==='下午12:30-6:30'){
      //   this.$dialog.alert({
      //     title: "预约失败",
      //     message: `2021-02-10(下午)至2021-02-16为法定休息日,暂不能预约!`
      //   }).then(() => {
      //     // sessionStorage.setItem('appointmentTime','2021-02-17');
      //     this.form.appointmentTime = '';
      //     this.currentDate=''
      //   });
      // }
      // if ( this.timeFormat(val) === '2021-02-11' || this.timeFormat(val) === '2021-02-12' || this.timeFormat(val) === '2021-02-13' || this.timeFormat(val) === '2021-02-14' || this.timeFormat(val) === '2021-02-15' || this.timeFormat(val) === '2021-02-16') {
      //   this.$dialog.alert({
      //     title: "预约失败",
      //     message: `2021-02-10(下午)至2021-02-16为法定休息日,暂不能预约!`
      //   }).then(() => {
      //     // sessionStorage.setItem('appointmentTime','2021-02-17');
      //     this.form.appointmentTime = '';
      //     this.currentDate=''
      //   });

      // }
      // this.form.appointmentTime = this.timeFormat(val);
      //选择的时间存入session
      sessionStorage.setItem('appointmentTime', this.timeFormat(val));
      this.showPicker = false;
    },
    //选择上午或者下午
    onChange(picker, value) {
      this.form.timeRange = value;
      this.columnsValue = value;
    },
    timeFormat(val) { // 时间格式化 2019-09-08
      let year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      return year + '-' + month + '-' + day;
    },
    myBook() {
      const data = {
        openId: sessionStorage.getItem('openId') || this.$route.query.id
      };
      getDetail(data).then(res => {
        this.form = res.data.data;
        if (this.form.length === 0) {
          this.$toast('没有您的预约信息!');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.$router.push({path: 'order', query: {openId: this.$route.query.openId}});
        }
      });
    }
  },
  mounted() {
  }
};
</script>
<style lang='less' scoped>
body {
  margin: 0;
  padding: 0;

  a {
    color: black;
  }

}

.about {
  width: 750px;
  background: linear-gradient(to right, #1343CF, #0c7fd8);
  padding-bottom: 10px;
}

img {
  width: 100%;
}

.center {
  width: 690px;
  margin: 20px auto;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px 10px;

  .van-cell {
    height: 100px;
    align-items: center;
    font-size: 32px;
    justify-content: space-around;
    font-weight: 600;

    .van-cell__value {
      font-size: 28px;
      height: 28px;
      flex: 2;
    }
  }
}

.order {
  width: 580px;
  height: 80px;
  border: none;
  background-color: #48BB9C;
  border-radius: 30px;
  color: #ffffff;
  font-size: 40px;
  //font-weight: bold;
  margin-top: 20px;
}

.myOrder {
  width: 580px;
  height: 80px;
  border: 1px solid #48BB9C;
  background-color: #fff;
  border-radius: 30px;
  color: #333333;
  font-size: 40px;
  margin-top: 20px;
}

.content {
  position: absolute;
  left: 0px;
}

.van-button {
  height: 80px;
  background-color: #48BB9C;
  border: none;
  font-size: 32px;
  margin-bottom: 32px;
}

//.van-ellipsis{
//  overflow:visible ;
//}
.end {
  width: 100%;
  margin: 40px 0 125px 0;
  //margin-bottom: 125px;
  color: #fff;
  font-size: 28px;
  //display: flex;
  //flex-direction: column;
  line-height: 25px;
  padding-left: 40px;
  box-sizing: border-box;

  h4 {
    font-size: 32px;
    line-height: 50px;
    margin: 10px 0;
  }

  p {
    font-size: 28px;
  }
}

.secondButton {
  background-color: #fff;
  color: #333333;
  border: 1px solid #48BB9C;
}

.timechoose {
  float: left;
}
</style>
